import { Container } from '@mui/material'
import ProjectBreadcrumb from '../project-tables/ProjectBreadcrumb'
import ApprovalPolicyList from './ApprovalPolicyList'

export default function ApprovalPoliciesPage() {
  return (
    <Container maxWidth="md">
      <ProjectBreadcrumb label="Approvals" url="../approvals" />

      <ApprovalPolicyList />
    </Container>
  )
}
